import React from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {useEventsContext} from "@/pages/dashboard/EventsContext";

export default function InvitationCreatorYear(props) {
  const {subtitle} = props;
  const {filteredInvitations, isLoadingInvitations} = useEventsContext();

  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Breakdown of who invited the partner"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  // Chart labels for the two categories
  const labels = ['Invited by Educator', 'Invited by Steward']

  // Calculate total invites from educators (connect + decline + pending questions)
  const totalInvites = filteredInvitations.length

  // Calculate total invites from stewards
  const totalStewardInvites = filteredInvitations.reduce((acc, invitation) => {
    if (invitation.eventCreatorId === invitation.creatorId) {
      return acc;
    }
    return acc + 1;
  }, 0);

  // Educator invites = Total invites - Steward invites
  const educatorInvites = totalInvites - totalStewardInvites

  // Data series for the donut chart [educator invites, steward invites]
  const series = [educatorInvites, totalStewardInvites]

  return (
    <DonutChart
      title="Breakdown of who invited the partner"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.yellow['400']
      ]}
    />
  );
}
